// Multi Unit 的保险公司选项与 Job 编辑表单共用同一数据源，并按输入内容过滤。
export function addJobMultiUnitPopUpRun({ sectionComponent } = {}) {
  // 新增表单的 JobId 取当前详情页上下文，避免由客户端提交任意 Job 归属。
  const jobId = sectionComponent?.props?.searchParameter?.jobId;
  if (jobId) sectionComponent.customForm.current?.formRef.current?.setFieldValue('JobId', jobId);
}

// 按编号范围批量创建
export function showBulkAdd({ sectionComponent, pageComponent } = {}) {
  sectionComponent?.setState({ bulkAddModalShow: true });
}

export function insuranceProviderChange({ parameter, sectionComponent } = {}) {
  const form = sectionComponent.customForm.current;
  const componentDataSource = form?.state.componentDataSource || {};
  if (componentDataSource.AllInsuranceProvider === undefined) {
    componentDataSource.AllInsuranceProvider = componentDataSource.InsuranceProvider || [];
  }
  componentDataSource.InsuranceProvider = parameter
    ? componentDataSource.AllInsuranceProvider.filter(item => (item.label || '').toLowerCase().includes(parameter.toLowerCase()))
    : componentDataSource.AllInsuranceProvider;
  form?.setState({ componentDataSource });
}
